import React, { useEffect, useState } from "react"
import { FaArrowUp } from "react-icons/fa"

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false)

    // Configurable variables
    const scrollThreshold = 15
    const hideThreshold = 95
    const scrollButtonSize = 15

    const handleScroll = () => {
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop
        const documentHeight =
            document.documentElement.scrollHeight -
            document.documentElement.clientHeight
        const scrollPercentage = (scrollTop / documentHeight) * 100

        if (
            scrollPercentage > scrollThreshold &&
            scrollPercentage <= hideThreshold
        ) {
            setIsVisible(true)
        } else {
            setIsVisible(false)
        }
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        })
    }

    useEffect(() => {
        window.addEventListener("scroll", handleScroll)
        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    }, [])

    return (
        <div
            className={`fixed bottom-14 right-16 md:right-32 cursor-pointer rounded-full bg-black p-3 text-white transition-opacity ${
                isVisible ? "opacity-75" : "opacity-0"
            }`}
            onClick={scrollToTop}>
            <FaArrowUp size={scrollButtonSize} />
        </div>
    )
}

export default ScrollToTop
